import { createFileRoute } from "@tanstack/react-router";

import { GroupMembersList } from "@/components/groups/group-members-list";
import { useGroupRouteData } from "@/hooks/use-group-route-data";

export const Route = createFileRoute("/_authenticated/app/groups/$groupId/members")({
  component: GroupMembersTab,
});

function GroupMembersTab() {
  const { groupId, group } = useGroupRouteData(Route.useParams().groupId);

  return (
    <div className="mx-auto max-w-180">
      <GroupMembersList
        groupId={groupId}
        isAdmin={false}
        visibility={group?.visibility ?? (group?.isPrivate ? "secret" : "public")}
        isGlobal={group?.isGlobal ?? false}
      />
    </div>
  );
}
